import axios from "axios";
import { constants } from '../config'

export default class ManufacturersService {

    static async get(page,limit, actives, search,listAll) {
        return axios.get(constants.api + '/aircraft-manufacturers',{
            params:{
                page:page?page:null,
                limit:limit?limit:null,
                actives:actives,
                search:search?search:null,
                listAll:listAll?listAll:null
            }
        })
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }

    static async search(search,page,pageSize) {
        return axios.post(constants.api + '/aircraft-manufacturer-search/'+page,{search},{
            params:{
                limit:pageSize
            }
        })
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }
    static async getActive() {
        return axios.get(constants.api + '/aircraft-manufacturers-actives')
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }

    static async getById(id) {

        return axios.get(constants.api + '/aircraft-manufacturer/'+ id)
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }

    static async update(id, data) {
        return axios.put(constants.api + '/aircraft-manufacturer/' + id, data)
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }
    static async create(data) {
        return axios.post(constants.api + '/aircraft-manufacturer', data)
            .then(response => {
                if (response.status) {
                    return {
                        response: response.data,
                        ok: true,
                    }
                }
                else {
                    return {
                        ok: false

                    };
                }
            }).catch(error => {
                return {
                    ok: false
                }
            })
    }
    



}


// WEBPACK FOOTER //
// ./src/tools/ManufacturersService.js